import * as React from "react";

import { ChatContext } from "@/contexts/ChatContextTypes";

// Custom hook for using the chat context
export const useChat = () => {
  const context = React.useContext(ChatContext);

  if (context === undefined) {
    throw new Error("useChat must be used within a ChatProvider");
  }

  return context;
};
